(() => {
  const ROOT_SELECTOR = 'jc-general-product, jc-playboy-product, jc-reta-product, jc-invincible-product, jc-suppressa-product';

  const clamp = (value, min, max) => Math.min(max, Math.max(min, Number.parseInt(value, 10) || min));

  const initialiseSelector = (selector) => {
    if (!selector || selector.dataset.quantityReady === 'true') return;
    selector.dataset.quantityReady = 'true';

    const input = selector.querySelector('[data-jc-quantity-input]');
    const decrease = selector.querySelector('[data-jc-quantity-decrease]');
    const increase = selector.querySelector('[data-jc-quantity-increase]');
    const root = selector.closest(ROOT_SELECTOR);
    if (!input) return;

    const min = Number.parseInt(input.min, 10) || 1;
    const max = Number.parseInt(input.max, 10) || 99;

    const refreshButtons = () => {
      const quantity = clamp(input.value, min, max);
      input.value = quantity;
      if (decrease) decrease.disabled = quantity <= min;
      if (increase) increase.disabled = quantity >= max;
    };

    const commit = (nextValue) => {
      const quantity = clamp(nextValue, min, max);
      input.value = quantity;

      if (root) {
        if (root.selectedPurchase === 'subscription') {
          root.subscriptionQty = quantity;
        } else {
          root.oneTimeQty = quantity;
        }

        if (typeof root.setPurchase === 'function') {
          root.setPurchase(root.selectedPurchase || 'one_time', true);
        }
      }

      root?.dispatchEvent(new CustomEvent('jc:quantity-change', {
        bubbles: true,
        detail: { quantity, purchaseType: root?.selectedPurchase || 'one_time' }
      }));
      refreshButtons();
    };

    decrease?.addEventListener('click', () => commit(Number(input.value) - 1));
    increase?.addEventListener('click', () => commit(Number(input.value) + 1));
    input.addEventListener('change', () => commit(input.value));
    input.addEventListener('blur', () => commit(input.value));

    root?.addEventListener('jc:purchase-change', refreshButtons);
    refreshButtons();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll?.('[data-jc-quantity-selector]').forEach(initialiseSelector);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
